import { render, staticRenderFns } from "./supplierBidDetails.vue?vue&type=template&id=3b15a597&scoped=true"
import script from "./supplierBidDetails.vue?vue&type=script&lang=js"
export * from "./supplierBidDetails.vue?vue&type=script&lang=js"
import style0 from "./supplierBidDetails.vue?vue&type=style&index=0&id=3b15a597&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b15a597",
  null
  
)

export default component.exports